export var TagRequestType;
(function (TagRequestType) {
    TagRequestType[TagRequestType["Edit"] = 0] = "Edit";
    TagRequestType[TagRequestType["Delete"] = 1] = "Delete";
    TagRequestType[TagRequestType["Add"] = 2] = "Add";
    TagRequestType[TagRequestType["Load"] = 3] = "Load";
})(TagRequestType || (TagRequestType = {}));
